import { useQuery } from '@tanstack/react-query'; // Note that we are NOT using our hand-rolled one because this doesn't return Response.data
import type { QueryKey } from '@tanstack/react-query';
import { blobText } from '../../../redux/api';
import { nuc } from '../../../utils';

function getRevisionFileBlob(revisionLocator: string, filePath: string) {
  return blobText(`/api/revisions/${nuc(revisionLocator)}/blob/${nuc(filePath)}`);
}

const getQueryKey = (revisionLocator: string, filePath: string): QueryKey =>
  ['revisions', revisionLocator, 'blob', filePath];

/**
 * Fetch a the Blob of a file by revision.
 *
 * @param {string} revisionLocator - The locator of the revision to fetch. No need to call nuc before passing it in here.
 * @param {string} filePath - The path of the file to fetch.
 */
export default function useRevisionFileBlob(
  revisionLocator: string,
  filePath: string,
) {
  return useQuery({
    queryKey: getQueryKey(revisionLocator, filePath),
    queryFn: () => getRevisionFileBlob(revisionLocator, filePath),
  });
}
